import React from "react";
import PropTypes from "prop-types";
import RootNavItem from "./components/RootNavItem";
import { Flex, Link, Text, withTranslation } from "@familyzone/component-library";
import AuthorizationWrapper from "../../modules/AuthorizationWrapper";
import { v4 as uuid } from "uuid";
import { getNavRoutes } from "./navRoutes";
import { getApplianceNavRoutes } from "./applianceRoutes";
import { useSessionStore } from "../../storez/SessionStore";

class Nav extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      navItems: [],
      remoteSupportAdmin: !!useSessionStore.getState().remoteSupportAdmin,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.path === "/devices" || props.path === "/device/create" || props.path === "/account") {
      return { navItems: getApplianceNavRoutes(props.t) };
    }
    return { navItems: getNavRoutes(props.t, props.menuFeatureToggles) };
  }

  componentWillMount() {
    this.unsubscribe = useSessionStore.subscribe(this.onSessionChange);
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = undefined;
    }
  }

  onSessionChange = () => {
    this.setState({
      remoteSupportAdmin: !!useSessionStore.getState().remoteSupportAdmin,
    });
  };

  is_selected = (path) => {
    return !!this.props.path.startsWith(path);
  };

  renderNavItems() {
    return this.state.navItems
      .filter((rootItem) => !rootItem.hidden)
      .filter((rootItem) => !rootItem.remoteSupportAdminOnly || this.state.remoteSupportAdmin)
      .map((rootItem) => (
        <AuthorizationWrapper allowedRoles={rootItem.allowedRoles} key={uuid()}>
          <RootNavItem
            name={rootItem.name}
            to={rootItem.to}
            icon={rootItem.icon}
            childItems={rootItem.childItems}
            dataCy={rootItem.dataCy}
            isActive={this.is_selected(rootItem.to)}
            forceShowChildren={rootItem.forceShowChildren || this.props.path.startsWith(rootItem.to)}
            currentPath={this.props.path}
            isNew={rootItem.isNew}
            remoteSupportAdmin={this.state.remoteSupportAdmin}
          />
        </AuthorizationWrapper>
      ));
  }

  render() {
    return (
      <React.Fragment>
        {this.props.path !== "/devices" && (
          <Flex
            id="main-menu"
            direction="column"
            bg="neutrals.0"
            height="100%"
            width="220px"
            flexShrink="0"
            position="sticky"
            top="0"
            paddingTop={"6px"}
          >
            <Flex
              direction="column"
              overflowY="scroll"
              overflowX="hidden"
              flex="1"
              css={{
                msOverflowStyle: "none" /* Internet Explorer 10+ */,
                scrollbarWidth: "none" /* Firefox */,
                "&::-webkit-scrollbar": {
                  display: "none" /* Safari and Chrome */,
                },
              }}
            >
              {this.renderNavItems()}
            </Flex>
            <Flex direction="row" alignItems="center" justifyContent="center" p="sp12" flexShrink="0">
              <Link href="https://qoria.com/privacy" isExternal>
                <Text fontSize="xs">Privacy Policy</Text>
              </Link>
              <Text fontSize="xs" paddingX="sp4" aria-hidden="true">
                |
              </Text>
              <Link href="https://qoria.com/legal/terms-of-service" isExternal>
                <Text fontSize="xs">Terms of Service</Text>
              </Link>
            </Flex>
          </Flex>
        )}
      </React.Fragment>
    );
  }
}

Nav.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default withTranslation()(Nav);
